import api from './api';

class AdminsService {
  // Get all admin with filters and pagination
  async getAllAdmin(params = {}) {
    try {
      const response = await api.get('/admins', { params });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async createAdmin(data) {
    try {
      const response = await api.post('/admins', data)

      return response.data;
    } catch (e) {
      throw this.handleError(e)
    }
  }

  // Update admin
  async updateAdmin(id, data) {
    try {
      const response = await api.put(`/admins/${id}`, data);
      return response.data.admin;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Delete admin
  async deleteAdmin(id) {
    try {
      const response = await api.delete(`/admins/${id}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Verify admin identity
  async verifyAdmin(id, data) {
    try {
      const response = await api.put(`/admin/${id}/verify`, data);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Block/unblock admin
  async toggleAdminStatus(id) {
    try {
      const response = await api.put(`/admin/${id}/toggle-status`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Get admin bookings
  async getAdminBookings(id, params = {}) {
    try {
      const response = await api.get(`/admin/${id}/bookings`, { params });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Get admin payments
  async getAdminPayments(id, params = {}) {
    try {
      const response = await api.get(`/admin/${id}/payments`, { params });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Export admin
  async exportAdmins(params = {}) {
    try {
      const response = await api.get('/admin/export', {
        params,
        responseType: 'blob'
      });
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      
      // Get filename from response headers
      const disposition = response.headers['content-disposition'];
      const filename = disposition 
        ? disposition.split('filename=')[1]?.replace(/['"]/g, '') 
        : 'admin_export.csv';
      
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      return { success: true, message: 'Export completed successfully' };
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Get admin verification status options
  getVerificationStatusOptions() {
    return [
      { value: 'pending', label: 'Pending', color: '#ff9800' },
      { value: 'verified', label: 'Verified', color: '#4caf50' },
      { value: 'rejected', label: 'Rejected', color: '#f44336' },
    ];
  }

  // Get admin statistics
  async getAdminStats(params = {}) {
    try {
      const response = await api.get('/admin/stats', { params });
      return response.data;
    } catch (error) {
      // Handle 501 (not implemented) by returning mock data
      if (error.response?.status === 501) {
        console.warn('Admin stats endpoint not implemented, returning mock data');
        return this.getMockAdminStats();
      }
      throw this.handleError(error);
    }
  }

  // Get admin status options
  getAdminStatusOptions() {
    return [
      { value: 'active', label: 'Active', color: '#4caf50' },
      { value: 'blocked', label: 'Blocked', color: '#f44336' },
      { value: 'suspended', label: 'Suspended', color: '#ff9800' },
    ];
  }

  // Mock admin stats for when endpoint is not implemented
  getMockAdminStats() {
    return {
      total_admin: 1247,
      active_admin: 1156,
      blocked_admin: 45,
      suspended_admin: 12,
      verified_admin: 1089,
      new_admin_today: 8,
      new_admin_this_week: 34,
      new_admin_this_month: 157,
      admin_growth_percentage: 12.5,
      verification_rate: 87.4,
      login_rate: 73.2
    };
  }

  // Handle API errors
  handleError(error) {
    if (error.response?.data?.message) {
      return new Error(error.response.data.message);
    } else if (error.message) {
      return new Error(error.message);
    } else {
      return new Error('An unexpected error occurred');
    }
  }
}

export default new AdminsService();